export default "__VITE_ASSET__56799b23__"